import { colours } from "../../ApartmentFinderConfig/colours"
import styled from "styled-components"

export const PlanFavouriteContainer = styled.div`
  height: calc(100% - 10rem);
  max-width: 800px;
  width: 90vw;
  width: max-content;
  flex-direction: column;
  background-color: #fff;
  display: flex;
`
export const TitleBar = styled.div`
  padding: 0% 10%;
  /* padding-right: 20%; */
  flex: 1;
  background-color: ${colours.primaryUI};
  display: flex;
  justify-content: space-between;
`
export const FloorPlan = styled.div`
  /* border: green 2px solid; */
  background-color: rgba(0, 0, 0, 0);
  background-color: white;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  flex: 4;
  /* background-size: cover; */
`
export const InfoHolder = styled.div`
  border-top: ${colours.primaryUI} 5px solid;
  flex: 2;
  justify-content: space-between;
  display: flex;
  /* background-color: green; */
`

export const ElevationHolder = styled.div`
  flex: 2;
  display: flex;
  /* border: red solid 2px; */
  /* width: 100%; */
  max-height: 150px;
  justify-content: flex-end;
  /* margin: 6% 2%; */
  padding: 2% 0%;
  /* justify-content: center; */
  /* align-items: flex-end; */
`

export const Dimensions = styled.div`
  flex: 2;
  /* border: red solid 2px; */
  flex-basis: 1;
  /* margin: 1%; */
  padding-top: 2%;
  padding-bottom: 2%;
  padding-left: 2%;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  display: flex;
`
export const FloorTitle = styled.h2`
  padding: 0;
  flex-direction: column;
  justify-content: left;
  align-items: center;

  display: flex;

  margin: 2% 0%;
  /* font-family: "Lora"; */
  font-size: 1rem;
  font-weight: 100;
  color: ${colours.secondaryUI};
`
export const PlotTitle = styled.h1`
  padding: 0;
  margin: 2% 0%;
  flex-direction: column;
  justify-content: left;
  align-items: center;

  display: flex;

  color: ${colours.secondaryUI};
  font-size: 1rem;

  font-weight: 100;
`
export const BedTitle = styled.h4`
  padding: 0;
  margin: 2% 0%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  display: flex;

  margin: 0;
  color: ${colours.secondaryUI};
  font-size: 1rem;

  font-weight: 100;
`
